export enum BotMaType {
  SMA = 'SMA',
  EMA = 'EMA',
}
